/** Tên trang Máy store trong menu và dòng phụ của trang: ở từ điển chung, vì menu và tiêu đề trang dùng ở mọi trang. */
export const storeMachinesNav: Record<string, string> = {
  'nav.admin.storeMachines': 'Máy store',
  'pageSub.storeMachines': 'Máy thu thập báo cáo Play và payment receipt',
}
